import mockEvents from './calendar';
import mockChats from './chats';
import mockContacts from './contacts';
import { mockFolders, mockFolders2, mockTags, mockMessages } from './messages';
import { mockNotifications, mockStats, mockTodo } from './notifications';
import mockTimeline from './timeline';
import mockActivity from './activity';
import mockInvoice from './invoice';
import mockPricing from './pricing';
import mockTaskboard from './taskboard';
import mockFeed from './feed';
import mockProduct from './product';
import mockReviews from './reviews';
import { mockChart } from './chart';
import mockDashboard from './dashboard';

export {
    mockEvents,
    mockChats,
    mockContacts,
    mockFolders,
    mockFolders2,
    mockTags,
    mockMessages,
    mockNotifications,
    mockStats,
    mockTodo,
    mockTimeline,
    mockActivity,
    mockInvoice,
    mockPricing,
    mockTaskboard,
    mockFeed,
    mockProduct,
    mockReviews,
    mockChart,
    mockDashboard,
};
